module.exports = __webpack_public_path__ + "img/img3.54068efd.png";